export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_51-a289a67286792ec35affa55ae001e8ed.jpg";